import React, { useEffect, useRef, useState } from "react";
import '../App.css'
import {
  Layout,
  Dropdown,
  Popover,
  Modal,
  Button,
  message,
  Form, Input, Row, Col
} from "antd";
import MenuComponent from "../components/Menu";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ModelMenuComp from "../components/ModelMenu";
import BreedMenuComp from "../components/BreedMenu";
import PhenoMenuComp from "../components/Pheno";
import { QrcodeOutlined ,CommentOutlined} from "@ant-design/icons";
import http from "../utils/http";
import ContactComponent from "../components/ContactComponent";
// import ChangePwdModalPwd from "../components/ChangePwdModal";
// import ContactComponent from "../components/ContactComponent";

const { Header, Content, Footer } = Layout;
const FixedStyle = {
  width: "60px",
  height: "280px",
  position: "fixed",
  bottom: "20px",
  right: "20px",
  zIndex: "999",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
const MainLay = () => {
  const BackImg = "../assets/img/背景图.png";

  const navigate = useNavigate();
  const location = useLocation();
  const [pathname, setPathname] = useState("");
  useEffect(() => {
    setPathname(location.pathname);
    console.log(location);
  }, [location]);
  const [TopKey, setTopKey] = useState("");
  useEffect(() => {
    setTopKey(sessionStorage.getItem("breedKey"));
  }, [sessionStorage.getItem("breedKey")]);
  const [RoleVal, setRoleVal] = useState(sessionStorage.getItem("role"));
  const ChageLefrMenuFn = () => {
    if (TopKey == 4) {
      return <ModelMenuComp />;
    } else if (TopKey == 5) {
      return <BreedMenuComp />;
    } else if (TopKey == 3) {
      return <PhenoMenuComp />;
    }
  };
  const [UserVal, setUserVal] = useState(
    sessionStorage.getItem("username")
      ? sessionStorage.getItem("username")
      : "no"
  );
useEffect(()=>{
  setUserVal(sessionStorage.getItem("username")
  ? sessionStorage.getItem("username")
   : "no")
},[sessionStorage.getItem("username")])
 
  const [headerBackground, setHeaderBackground] = useState("#F0F7FD");
  const [headerHeight, setHeaderHeight] = useState("80px");
  const contentRef = useRef(null);

  // 监听路由变化
  useEffect(() => {
    if (location.pathname === "/Breeding/home/") {
      // 当路由到首页时
      setHeaderBackground("#F0F7FD"); // 设置背景色
      setHeaderHeight("80px"); // 设置高度

      // 确保内容区域滚动到顶部
      if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    } else {
      // 其他页面时的默认样式
      setHeaderBackground("#fff");
      setHeaderHeight("80px");
    }
  }, [location.pathname]);

  // 监听滚动事件
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/Breeding/home/") {
        if (contentRef.current) {
          const scrollTop = contentRef.current.scrollTop;
          if (scrollTop > 0) {
            setHeaderBackground("#fff");
            setHeaderHeight("70px");
          } else {
            setHeaderBackground("#F0F7FD");
            setHeaderHeight("80px");
          }
        }
      }
    };

    const content = contentRef.current;
    if (content) {
      content.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (content) {
        content.removeEventListener("scroll", handleScroll);
      }
    };
  }, [location.pathname]);
const CodeText=()=>{
  return <div
  style={{
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
  }}
  >
    {/* <div
    style={{
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
    }}
    >
      <p>企业微信</p>
      <img src={require('../assets/img/Homev2/wecom.png')} alt="" />
    </div> */}
    <div
     style={{
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
    }}
    >
      <p>企业微信</p>
      <img src={require('../assets/img/Homev2/wecom.png')} style={{
        width:"170px",
        height:"200px"

      }} alt="" />

    </div>
  </div>
}
const [IsShowModal, setIsShowModal] = useState(false);
const showModal=()=>{
  setIsShowModal(true)
}
  const handleOk = () => {
    setIsShowModal(false);
  };
  const handleCancel = () => {
    setIsShowModal(false);
  };

  const [form] = Form.useForm();
  const onfinish = (values) => {
    console.log(values);
  };
  const [UserInfo, setUserInfo] = useState({});
  const [IsLogin,setIsLogin]=useState(false)
   useEffect(() => {
    if(!sessionStorage.getItem('access_token'))return
      http
        .get("/api/users/userInfo/")
        .then((res) => {
          setUserInfo(res);
          setIsLogin(true)
        })
        .catch((err) => {
          console.log(err)
          setIsLogin(false)
        });
    }, []);
    useEffect(()=>{

    },[sessionStorage.getItem('access_token')])
    const [isModalChangepwd,setIsModalChangePwd]=useState(false)
    const showModalChangepwd=()=>{setIsModalChangePwd(true)};
    const handleCancelChangepwd=()=>{setIsModalChangePwd(false)};

  // 在组件顶部添加新的状态
const [editingField, setEditingField] = useState(null);
const [tempValue, setTempValue] = useState("");

// 添加字段修改函数
const handleFieldUpdate = async (field) => {
  try {
    await http.post("/api/users/infoUpload/", {
      [field]: tempValue
    });
    setUserInfo(prev => ({ ...prev, [field]: tempValue }));
    message.success("Change Success!");
    setEditingField(null);
  } catch (error) {
    message.error("Change Error!");
  }
};

    const popoverContent = (
      <div
        style={{
          width: "300px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <p style={{ margin: "5px 0", width: "100%" ,display:"flex",alignItems:"center",justifyContent:"center"}}>
          Email:{UserInfo?.email}
        </p>
        <div style={{ margin: "5px 0", width: "100%" ,display:"flex",alignItems:"center",justifyContent:"center"}}>
      {editingField === 'institution' ? (
        <Input 
          defaultValue={UserInfo?.institution}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={() => handleFieldUpdate('institution')}
          autoFocus
        />
      ) : (
        <div onClick={() => {
          setTempValue(UserInfo?.institution);
          setEditingField('institution');
        }}>
          Organization: {UserInfo?.institution}
        </div>
      )}
    </div>
    
    <div style={{ margin: "5px 0", width: "100%" ,display:"flex",alignItems:"center",justifyContent:"center"}}>
      {editingField === 'nickname' ? (
        <Input 
          defaultValue={UserInfo?.nickname}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={() => handleFieldUpdate('nickname')}
          autoFocus
        />
      ) : (
        <div onClick={() => {
          setTempValue(UserInfo?.nickname);
          setEditingField('nickname');
        }}>
          Nick Name: {UserInfo?.nickname}
        </div>
      )}
    </div>

    <div style={{ margin: "5px 0", width: "100%" ,display:"flex",alignItems:"center",justifyContent:"center"}}>
      {editingField === 'mobile' ? (
        <Input 
          defaultValue={UserInfo?.mobile}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={() => handleFieldUpdate('mobile')}
          autoFocus
        />
      ) : (
        <div onClick={() => {
          setTempValue(UserInfo?.mobile);
          setEditingField('mobile');
        }}>
          Mobile phone number: {UserInfo?.mobile}
        </div>
      )}
    </div>
        <Button
          type="primary"
          onClick={() => {
            showModalChangepwd()
          }}
          style={{ width: "200px", margin: "5px 0" }}
        >
          Change Password
        </Button>
        <Button
          danger
          onClick={() => {
            sessionStorage.removeItem("username");
            setUserVal("no");
            setUserInfo({})
            message.success("Exited successfully");
            sessionStorage.removeItem("access_token");
            sessionStorage.removeItem("refresh_token");
            sessionStorage.setItem("breedKey", 1);
            sessionStorage.removeItem("role");
            // sessionStorage.clear();
            navigate("/Breeding/home/");
            setPathname("/Breeding/home/")
          }}
          style={{ width: "200px", margin: "5px 0" }}
        >
          Logout
        </Button>
      </div>
    );
  return (
    <Layout style={{minWidth:"1280px", height: "100%" }}>
      {/* <ContactComponent
      IsOpen={IsShowModal}
      OkFn={handleOk}
      CancenFn={handleCancel}
      setIsOpen={setIsShowModal}
/> */}
      
            {/* <ChangePwdModalPwd
            IsChangePwdModal={isModalChangepwd}
            handCancelFn={handleCancelChangepwd}
            setIsChangePwdModal={setIsModalChangePwd} 
            /> */}
    <div style={FixedStyle}>
      
      <div
        style={{
          width: "100%",
          height: "60%",
          background: "#fff",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
         <div
            style={{
              width: "100%",
              height: "49.9%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            className="Fixed_hover"
            onClick={()=>{
              showModal()
              // window.open('#/Breeding/message/', '_blank');
            }}
          >
            <CommentOutlined
              style={{
                fontSize: "25px",
              }}
            />
            <p
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>Message</span>
              {/* <span>咨询</span> */}
            </p>
          </div>
        <p
          style={{
            width: "50%",
            height: "1px",
            background: "#ccc",
          }}
        ></p>

        <Popover placement="left" content={CodeText()}>
          <div
            style={{
              width: "100%",
              height: "49.9%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            className="Fixed_hover"
          >
            <QrcodeOutlined
              style={{
                fontSize: "25px",
              }}
            />
            <p
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>Contact</span>
              {/* <span>我们</span> */}
            </p>
          </div>
        </Popover>
      </div>
    </div>
    <ContactComponent
      IsOpen={IsShowModal}
      OkFn={handleOk}
      CancenFn={handleCancel}
      setIsOpen={setIsShowModal}
/>
      {location.pathname === "/Breeding/home/" ? (
        <Header
          style={{
            padding: "10px 0",
            height: headerHeight,
            position: "sticky",
            top: 0,
            zIndex: 100,
            width: "100%",
            display: "flex",
            alignItems: "center",
            margin: "0",
            background: headerBackground,
            transition: "all 0.3s ease",
          }}
        >
          <Row
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Col
              span={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <img
                src={require("../assets/img/logo2.png")}
                style={{ height: "100%" }}
                alt=""
              />
              <span style={{ fontSize: "30px", margin: "0 10px" }}>|</span>
              <p style={{ fontSize: "20px", fontWeight: "bold" }}>BioAIBP</p>
              {/* <img
                src={require("../assets/img/Home_header.png")}
                style={{ height: "30%", objectFit: "cover" }}
                alt=""
              /> */}
            </Col>
            <Col
              span={13}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "30px",
              }}
            >
              <MenuComponent />
            </Col>
            <Col
              span={5}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: "30px",
              }}
            >
              {/* <img
                src={require("../assets/img/User.png")}
                style={{ width: "5%" }}
                alt=""
              /> */}
              {Object.keys(UserInfo).length == 0 ? (
                <Button
                  onClick={() => navigate("/login")}
                  style={{
                    margin: "0 10px",
                    background: "linear-gradient(to right, #48C9C7, #487FCB)",
                    border: "none",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Login
                </Button>
              ) : (
                <Popover
              content={popoverContent}
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                 
                  <span> {UserInfo?.username}</span>
                </div>
              }
              trigger="hover"
            >
              <div style={{ cursor: "pointer" }}>
                <span> {UserInfo?.username}</span>
              </div>
            </Popover>
              )}
            </Col>
          </Row>
        </Header>
      ) : (
        <Header
          style={{
            padding: "10px 0",
            height: "80px",
            position: "sticky",
            top: 0,
            zIndex: 100,
            width: "100%",
            display: "flex",
            alignItems: "center",
            margin: "0",
            borderBottom: "2px solid #ccc",
            background: "#fff",
          }}
        >
          <Row
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Col
              span={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <img
                src={require("../assets/img/logo2.png")}
                style={{ height: "100%" }}
                alt=""
              />
              <span style={{ fontSize: "30px", margin: "0 10px" }}>|</span>
              <p style={{ fontSize: "20px", fontWeight: "bold" }}>BioAIBP</p>
              {/* <img
                src={require("../assets/img/Home_header.png")}
                style={{ height: "30%", objectFit: "cover" }}
                alt=""
              /> */}
            </Col>
            <Col
              span={13}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "30px",
              }}
            >
              <MenuComponent />
            </Col>
            <Col
              span={5}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: "30px",
              }}
            >
              {/* <img
                src={require("../assets/img/User.png")}
                style={{ width: "5%" }}
                alt=""
              /> */}
              {Object.keys(UserInfo).length == 0 ? (
                <Button
                  onClick={() => navigate("/login")}
                  style={{
                    margin: "0 10px",
                    background: "linear-gradient(to right, #48C9C7, #487FCB)",
                    border: "none",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Login
                </Button>
              ) : (
                <Popover
              content={popoverContent}
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                 
                  <span> {UserInfo?.username}</span>
                </div>
              }
              trigger="hover"
            >
              <div style={{ cursor: "pointer" }}>
                <span> {UserInfo?.username}</span>
              </div>
            </Popover>
              )}
            </Col>
          </Row>
        </Header>
      )}

      <Content
        style={{
          backgroundImage: `url(${BackImg})`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          height: "100%",
          overflow: "auto",
          background: "#fff",
        }}
        ref={contentRef}
      >
        {pathname == "/Breeding/home/" ||
        pathname == "/Breeding/alltask/" ||
        pathname == "/Breeding/account/" ||
        pathname == "" ? (
          <Outlet />
        ) : (
          <Layout
            style={{
              height: "100%",
            }}
          >
            {ChageLefrMenuFn()}
            <Content
              style={{
                padding: "0 10px",
                backgroundImage: `url(${BackImg})`,
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                background: "#fff",
                overflow: "auto",
              }}
            >
              <Outlet />
            </Content>
          </Layout>
        )}
      </Content>
      {/* {pathname != "/Breeding/home/" ? (
        <Footer
          style={{
            background: "#E1E7D9",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
            padding: "10px 0",
            lineHeight: "20px",
          }}
        >
          <p>
            <span style={{ color: "#a2a2a2" }}>
              Beijing Bio Huaxing Gene Technology Co., LTD
            </span>{" "}
            <a target="_blank" href="http://www.biohuaxing.com/">
              www.biohuaxing.com
            </a>
          </p>
          <p style={{ color: "#a2a2a2" }}>
            Comments or Questions? Please contact us: support@biohuaxing.com
          </p>
        </Footer>
      ) : (
        ""
      )} */}
    </Layout>
  );
};
export default MainLay;

